import { render, staticRenderFns } from "./index.vue?vue&type=template&id=12c323d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=12c323d6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c323d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12c323d6')) {
      api.createRecord('12c323d6', component.options)
    } else {
      api.reload('12c323d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=12c323d6&scoped=true", function () {
      api.rerender('12c323d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/CheckPage/index.vue"
export default component.exports